import { useMemo } from 'react';
import { ImageSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useComposerSection } from '../../hooks';
import { ImageWithDimensions, JustifiedLayout, SectionFrame } from '../sections/image-elements';

export const ImageOutput = () => {
  const { props, dom } = useComposerSection<ImageSection>();

  // TODO: Handle the unlikely edge case when images are still downloading into the editor and naturalHeight/naturalWidth is 0
  const imagesWithDimensions = useMemo(() => {
    const sourceImages = dom?.querySelectorAll('img[data-type="src-image"]');
    const imagesWithDimensions: ImageWithDimensions[] = [];

    sourceImages?.forEach((element) => {
      const sourceImage = element as HTMLImageElement;
      const url = sourceImage.src;
      const name = sourceImage.alt;
      const width = sourceImage.naturalWidth;
      const height = sourceImage.naturalHeight;

      if (url && width && height) {
        imagesWithDimensions.push({
          url,
          name,
          width,
          height,
        });
      }
    });

    return imagesWithDimensions;
  }, [dom]);

  return imagesWithDimensions.length !== 0 ? (
    <SectionFrame {...props.frame}>
      <JustifiedLayout
        alignment={props.frame?.alignment}
        corners={props.corners}
        height={props.height}
        imageSpacing={props.imageSpacing}
        images={imagesWithDimensions}
      />
    </SectionFrame>
  ) : null;
};
